import React from "react";
import { useLayerFunc } from "../Main/layerFunc";

function Bhukum() {

    const {
        LayerChange,
        SimpleTileLayerChange,
        handleOpen,
        GeoJsonLayerChange
    } = useLayerFunc();

    return (
        <>
            <details className="baseline">
                <summary>Bhukum</summary>

                <details id="townD">
                    <summary className="townS">Town Planning</summary>
                        <div className="town-cont">
                            <div className="opt-div">
                            <input value="SN_254_user_13_115115_upload" id="SN_254_user_13_115115_upload" className="form-check-input check-map" type="checkbox" 
                                onChange={(e) => GeoJsonLayerChange(e.target.value,e.target.checked,
                                    {
                                        color: "#ff0000",
                                        fillColor: "#ff0000",
                                        fillOpacity: 0.3
                                    })} />
                            <label>SN_254</label>
                            </div>

                            <div className="opt-div">
                            <input value="SN_637_user_13_115209_upload" id="SN_637_user_13_115209_upload" className="form-check-input check-map" type="checkbox" 
                                onChange={(e) => GeoJsonLayerChange(e.target.value,e.target.checked,
                                        {
                                            color: "#ff8800",
                                            fillColor: "#ff8800",
                                            fillOpacity: 0.3
                                        })} />
                            <label>SN 637</label>
                            </div>

                            <div className="opt-div">
                            <input value="Stream_4326_user_13_115353_upload" id="Stream_4326_user_13_115353_upload" className="form-check-input check-map" type="checkbox" 
                                onChange={(e) => GeoJsonLayerChange(e.target.value,e.target.checked,
                                        {
                                            color: "#00c3ff",
                                            fillColor: "#00c3ff",
                                            fillOpacity: 0.3
                                        })} />
                            <label>Stream</label>
                            </div>

                            <div className="opt-div">
                            <input value="Contour_4326_user_13_115549_upload" id="Contour_4326_user_13_115549_upload" className="form-check-input check-map" type="checkbox" 
                                onChange={(e) => GeoJsonLayerChange(e.target.value,e.target.checked,
                                        {
                                            color: "#000000",
                                            fillColor: "#000000",
                                            fillOpacity: 0.3
                                        })} />
                            <label>Contour</label>
                            </div>

                            <div className="opt-div">
                            <input value="UPDTD_POLY2_user_13_154024_upload" id="UPDTD_POLY2_user_13_154024_upload" className="form-check-input check-map" type="checkbox" 
                                onChange={(e) => GeoJsonLayerChange(e.target.value,e.target.checked,
                                        {
                                            color: "#fbff00",
                                            fillColor: "#fbff00",
                                            fillOpacity: 0.3
                                        })} />
                            <label>Plot</label>
                            </div>
                        
                        </div>
                </details>

                <details id="townD" className="baseline">
                    <summary className="townS">Satellite Images</summary>
                        <div className="town-cont">

                            <div className="opt-div">
                            <input value="bhukum_2021" id="bhukum_2021" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2021</label>
                            </div>

                            <div className="opt-div">
                            <input value="bhukum_2022" id="bhukum_2022" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2022</label>
                            </div>

                            <div className="opt-div">
                            <input value="bhukum_2023" id="bhukum_2023" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2023</label>
                            </div>

                            <div className="opt-div">
                            <input value="bhukum_2024" id="bhukum_2024" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2024</label>
                            </div>

                            <div className="opt-div">
                            <input value="bhukum_2025" id="bhukum_2025" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2025</label>
                            </div>

                            <div className="opt-div">
                            <input value="bhukum_2026" id="bhukum_2026" onChange={(e) => SimpleTileLayerChange(e.target.value ,e.target.checked)} className="form-check-input check-map" type="checkbox" />
                            <label>2026</label>
                            </div>
                            
                        </div>
                </details>

            </details>


        </>
    );
}

export default Bhukum;
